// API endpoints. Production talks to the Azure API Management gateway; when
// running the dev server (`npm start` sets NODE_ENV=development) the license
// and store APIs hit the Functions apps directly on localhost instead:
//   - LicenseManagement Functions app → :7072  (LicenseManagement)
//   - StoreAPIService Functions app   → :7036  (Payments, SalesTax)
// The Products API always goes through the gateway. A production build
// (`npm run build`) keeps every gateway URL.
const local = process.env.NODE_ENV === 'development';

export const LICENSE_MANAGEMENT_API_ADDRESS = local
  ? 'http://localhost:7072/api/LicenseManagement'
  : 'https://nuvolemapimanagement.azure-api.net/p/LicenseManagement';

export const PRODUCTS_API_ADDRESS =
  'https://nuvolemapimanagement.azure-api.net/Products';

export const SALES_TAX_API_ADDRESS = local
  ? 'http://localhost:7036/api/SalesTax'
  : 'https://nuvolemapimanagement.azure-api.net/p/SalesTax';

export const PAYMENTS_API_ADDRESS = local
  ? 'http://localhost:7036/api/Payments'
  : 'https://nuvolemapimanagement.azure-api.net/p/Payments';

// Stripe customer billing portal, where users review payments and cancel or
// update subscriptions. TODO: wire to a real per-customer portal session
// (created server-side) instead of this placeholder.
export const STRIPE_BILLING_PORTAL_URL = 'https://billing.stripe.com/';
